import { render, staticRenderFns } from "./indexPac.vue?vue&type=template&id=33de8c0d&scoped=true"
import script from "./indexPac.vue?vue&type=script&lang=js"
export * from "./indexPac.vue?vue&type=script&lang=js"
import style0 from "./indexPac.vue?vue&type=style&index=0&id=33de8c0d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33de8c0d",
  null
  
)

export default component.exports